import * as React from 'react';

import MainMenu from '../../containers/MainMenu';
import Navbar from '../../containers/Navbar';
import QuestionnaireFormContainer from '../../containers/QuestionnaireForm';
import i18n from '../../resources/i18n';
/**
 * アンケート回答画面
 * @param props
 */
const QuestionnaireForm: React.FC<any> = props => {
	const careerID = props.match.params.career_id;
	const classID = props.match.params.class_id;
	const id = props.match.params.questionnaire_id;
	const type = props.match.params.type;
	const flg: number = Number.parseInt(props.match.params.flg);

	return (
		<>
			<MainMenu />
			<Navbar title={i18n.t('QuestionnaireForm_0001')} />
			<QuestionnaireFormContainer
				careerID={careerID}
				classID={classID}
				id={id}
				type={type}
				flg={flg}
				assessmentFlg={false}
				onlyQuestionFlg={true}
			/>
		</>
	);
};

export default QuestionnaireForm;



// WEBPACK FOOTER //
// ./src/pages/personal/QuestionnaireForm.tsx